import React, {useRef, useState} from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {set} from 'object-path-immutable'
import Schema from "./Schema";
import Properties from "./Properties";
import findByString from "../../../Utils/Form/FormDynamic/Utils/getValueByString";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%'
    },
    schemaContainer: {
        width: '50%',
        borderRight: "1px solid #e8e8e8",
        height: '100%'
    },
    schema: {
        width: '100%',
        height: '95%',
        overflow: 'auto',
        padding: 15
    },
    propertiesContainer: {
        width: '50%',
        height: '100%'
    },
    properties: {
        width: '100%',
        height: '95%',
        overflow: 'auto',
        padding: 15
    },
    sideTitle: {
        background: "#f7f7f7"
    }
}));

const SchemaProperties = ({data, setValue, createNewItem, deleteItem, deleteValue, insertItems}) => {
    const classes = useStyles();
    const nameRef = useRef();
    const [selected, setSelected] = useState('');
    const [selectedObject, setSelectedObject] = useState({field: {}, disabled: false});

    const handleSelect = (event, path = '') => {
        const find = findByString(data, path);

        const isDisabled = () => {
            const isInherited = find ? Boolean(find.inherit) : false; //array data doesn't include inherited fields
            if (!isInherited && path && path.split('.').length > 1) {
                const findForParent = findByString(data, path.split('.')[0]);
                if (findForParent) {
                    return findForParent.type === 'entityEmbedded'
                }
            }
            return isInherited
        };
        setSelectedObject({field: find, disabled: isDisabled()});
        setSelected(path);
    };

    const focusFirstPropertyField = () => {
        if (nameRef.current) {
            nameRef.current.focus();
        }
    };

    const onChangeSelectedProps = (value, path, isOverridable) => {
        let newValues = set(selectedObject, path ? `field.${path}` : 'field', value);
        if (isOverridable) {
            newValues = set(newValues, `field.overridden`, true)
        }
        setSelectedObject(newValues)
    };

    return (
        <div className={classes.container}>
            <div className={classes.schemaContainer}>
                <div className={classes.sideTitle}>
                    <Typography color={"textSecondary"} align={"center"}>Fields</Typography>
                    <Divider/>
                </div>
                <div className={classes.schema}>
                    <Schema data={data}
                            handleSelect={handleSelect}
                            selected={selected}
                            createNewItem={createNewItem}
                            insertItems={insertItems}
                            deleteItem={deleteItem}
                            focusFirstPropertyField={focusFirstPropertyField}
                    />
                </div>
            </div>
            <div className={classes.propertiesContainer}>
                <div className={classes.sideTitle}>
                    <Typography color={"textSecondary"} align={"center"}>Properties</Typography>
                    <Divider/>
                </div>
                <div className={classes.properties}>
                    <Properties
                        selectedField={selectedObject}
                        selectedPath={selected}
                        setValue={setValue}
                        onChangeSelectedProps={onChangeSelectedProps}
                        nameRef={nameRef}
                        deleteValue={deleteValue}
                    />
                </div>
            </div>
        </div>
    )
};

export default SchemaProperties

SchemaProperties.propTypes = {
    data: PropTypes.array,
    setValue: PropTypes.func,
    createNewItem: PropTypes.func,
    deleteItem: PropTypes.func,
    insertItems: PropTypes.func
};

SchemaProperties.defaultProps = {
    inheritFields: [],
    data: []
};